const scrollService = {
  scrollToTop () {
    // document.documentElement.scrollTop = 0;
  },
  getScrollTop (id) {
    const obj = document.getElementById(id)
    return obj.scrollTop
  },
  addScrollListener (id, fun) {
    const obj = document.getElementById(id)
    obj.addEventListener('scroll', fun)
  },
  removeScrollListener (id, fun) {
    const obj = document.getElementById(id)
    obj.removeEventListener('scroll', fun)
  },
  isReachTop (id) {
    const obj = document.getElementById(id)
    return obj.scrollTop === 0
  },
  isReachBottom (id) {
    const obj = document.getElementById(id)
    return Math.ceil(obj.scrollTop) + obj.offsetHeight >= obj.scrollHeight
  }
}

export default scrollService
